// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"701bf92e","52":"c5f47f42","313":"96ea1094","322":"697e73cb","422":"8017f441","549":"5af28864","558":"6e84f900","654":"d0981b30","837":"57a7cb7d"}[chunkId] + ".chunk.js";
};